import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { IBanner, MAX_BANNERS } from 'rev-portal/scheduledEvents/common/BannerTypes';

import { EditWebcastBaseSettingsComponent } from './EditWebcastBaseSettings.Component';

@Component({
	selector: 'edit-webcast-banner-details',
	templateUrl: './EditWebcastBannerDetails.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => EditWebcastBannerDetailsComponent),
		multi: true
	}, {
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => EditWebcastBannerDetailsComponent),
		multi: true,
	}],
	standalone: false
})
export class EditWebcastBannerDetailsComponent extends EditWebcastBaseSettingsComponent implements ControlValueAccessor {
	@Input() public isSidebar = false;

	public readonly MAX_BANNERS = MAX_BANNERS;
	public readonly isDuplicateName = linkName => this.banners.filter(c => c.name === linkName).length > 1;
	public readonly isDuplicateNameForForm = linkName => this.banners.some((c, index) => c.name === linkName && index !== this.editingBannerIndex);

	public onTouched: () => void = () => undefined;
	public onChange: (banners: IBanner[]) => void = () => undefined;

	public banners: IBanner[] = [];
	public newBanner: IBanner | null = null;
	public isAddingNewBanner = false;
	public editingBannerIndex: number | null = null;

	public isAddNewDisabled(): boolean {
		return this.isAddingNewBanner || this.banners?.length >= this.MAX_BANNERS;
	}

	public onAddNewClick(): void {
		this.newBanner = {
			name: '',
			message: '',
			link: '',
			pushMethod: 'Manual'
		};
		this.editingBannerIndex = null;
		this.isAddingNewBanner = true;
	}

	public onEditEntry(index: number): void {
		this.newBanner = { ...this.banners[index] };
		this.editingBannerIndex = index;
		this.isAddingNewBanner = true;
	}

	public onCancelAddEntry(): void {
		this.newBanner = null;
		this.editingBannerIndex = null;
		this.isAddingNewBanner = false;
	}

	public onSaveEntry(banner: IBanner): void {
		if (this.editingBannerIndex !== null) {
			this.banners[this.editingBannerIndex] = {
				...this.banners[this.editingBannerIndex],
				...banner
			};
		} else {
			this.banners.push({ ...banner });
		}

		this.newBanner = null;
		this.editingBannerIndex = null;
		this.isAddingNewBanner = false;
	}

	public onDeleteEntry(index: number): void {
		this.banners.splice(index, 1);
	}

	public writeValue(links: IBanner[]): void {
		this.banners = links;
		if (!this.banners) {
			this.banners = [];
		}
	}

	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}
}
